<template>
  <list
    :list="options"
    :after-classes="['pb-5', 'border-b', 'border-gray-200']"
    :before-classes="['pt-5']"
  >
    <template #default="{ item, index }">
      <div
        class="flex flex-wrap -mx-4"
        :class="{'items-center': !horizontalQuiz, 'md:justify-center': horizontalQuiz}"
      >
        <!-- eslint-disable vue/no-v-html -->
        <div
          class="w-full px-4 text-center md:text-left"
          :class="{'md:w-1/2': !horizontalQuiz, 'md:w-11/12': horizontalQuiz}"
          v-html="item.title"
        />
        <!-- eslint-enable vue/no-v-html -->
        <option-group
          v-bind="bindings(item)"
          class="w-full px-4 mt-5"
          :class="{'md:w-1/2 md:mt-0': !horizontalQuiz, 'md:w-11/12 md:pl-4': horizontalQuiz}"
          @update:model-value="payload => setValue(item.name || index, payload)"
        />
        <slot
          :class="{'w-full px-4 md:w-1/2 md:mt-0': !horizontalQuiz, 'w-full px-4 md:w-11/12 md:pl-4': horizontalQuiz}"
        />
      </div>
    </template>
  </list>
</template>

<script>
import { List } from '../List';
import OptionGroup from './OptionGroup.vue';
import { props } from './props';

export default {
  components: {
    List,
    OptionGroup,
  },

  props: {
    ...props,

    modelValue: {
      type: Object,
      required: true,
    },
  },

  emits: ['update', 'input', 'update:modelValue'],

  methods: {
    bindings(item) {
      return {
        ...this.$props,
        ...item,
        modelValue: this.modelValue[item.name],
      };
    },

    setValue(key, value) {
      this.$emit('update', { key, value });
      this.$emit('update:modelValue', {
        ...this.modelValue,
        [key]: value,
      });
    },
  },
};
</script>
